import React from 'react';
import PropTypes from 'prop-types';
import { marked } from 'marked';

import { MarkdownStyles } from './Markdown.styled';

function Markdown({ markdown = '' }) {
  marked.setOptions({
    pedantic: false,
    gfm: true,
    tables: true,
    breaks: false,
    sanitize: false,
    smartLists: true,
    smartypants: false,
    xhtml: false,
    closeHtmlTags: true,
  });

  const htmlOutput = marked((markdown || '').trim()).replace(/\n/gm, '<br />');

  return (
    <MarkdownStyles>
      {markdown && (
        <div
          className="markdown"
          dangerouslySetInnerHTML={{ __html: htmlOutput }}
        />
      )}
    </MarkdownStyles>
  );
}

export default Markdown;

Markdown.propTypes = {
  markdown: PropTypes.string.isRequired,
};
